import type { RealestateAsset } from "~/types/assets.types";

export const calculateRealestateYears = (userProduct: RealestateAsset) => {
  const purchaseDate = userProduct?.purchaseDate || "";
  const currentDate = new Date();
  const purchasingDate = new Date(purchaseDate);
  const millisecondsInYear = 1000 * 60 * 60 * 24 * 365;
  const timeDifference = currentDate.getTime() - purchasingDate.getTime();
  const years = timeDifference / millisecondsInYear;
  return years || 0;
  // return currentDate.getFullYear() - purchasingDate.getFullYear() || 0;
};
